import { Filters } from "toptaal-shared"
import { MetaData } from "toptaal-shared"
import { LearningPath, StartingLevel } from "./learningPaths"
import { Exam, ExamTypeOwner, ModuleExamAssignment } from "./exams"
import { TeachingMaterial } from "./teachingMaterials"
import { z } from "zod"

export const hourTypeEnum = z.enum([
  "language_lessons",
  "alfa",
  "external_language_provider",
  "map",
  "pvt",
  "participation_hours",
])

export type HourType = z.infer<typeof hourTypeEnum>

export const hourTypesOptions: { label: string; value: HourType }[] = [
  { label: "Taallessen", value: "language_lessons" },
  { label: "Alfa", value: "alfa" },
  { label: "Externe taalaanbiedder", value: "external_language_provider" },
  { label: "Map", value: "map" },
  { label: "PVT", value: "pvt" },
  { label: "Participatie uren", value: "participation_hours" },
]

export interface ModuleExam {
  id: number
  examType: ExamTypeOwner
  exam: Exam
  examId: number
  lessonNumber: number
}

export type ModuleTeachingMaterial = Pick<TeachingMaterial, "id" | "title">

export interface Module {
  id: number
  organizationId: number
  startLevel: StartingLevel
  hourType?: HourType
  numberOfLessons: number
  lessonDurationInMinutes: number
  totalDurationInMinutes: number
  order: number
  moduleCode: string
  learningPathId: LearningPath["id"]
  updatedAt: string
  createdAt: string
  teachingMaterials?: ModuleTeachingMaterial[]
  toptaalTeachingMaterials?: ModuleTeachingMaterial[]
  examsToptaal?: ModuleExam[]
  examsCito?: ModuleExam[]
  examsVnt2?: ModuleExam[]
}

export interface ModuleTeachingMaterialAssignment {
  teachingMaterialId: number
}

export interface CreateModuleApiRequest {
  moduleCode: string
  startLevel: StartingLevel
  hourType: HourType
  toptaalTeachingMaterials: ModuleTeachingMaterialAssignment[]
  teachingMaterials: ModuleTeachingMaterialAssignment[]
  examsToptaal: ModuleExamAssignment[]
  examsCito: ModuleExamAssignment[]
  examsVnt2: ModuleExamAssignment[]
  lessonDurationInMinutes: number
  numberOfLessons: number | null
  order?: number | null
}

export interface UpdateModuleExternalTeachingMaterialsApiRequest {
  moduleId: Module["id"]
  teachingMaterials: ModuleTeachingMaterialAssignment[]
}

export interface UpdateModuleToptaalTeachingMaterialsApiRequest {
  moduleId: Module["id"]
  toptaalTeachingMaterials: ModuleTeachingMaterialAssignment[]
}

export interface UpdateModuleExamsApiRequest {
  moduleId: Module["id"]
  examsToptaal: ModuleExamAssignment[]
  examsCito: ModuleExamAssignment[]
  examsVnt2: ModuleExamAssignment[]
}

export interface ModulesFiltersRequest {
  filters: Filters
}

export interface ModulesApiResponse {
  data: {
    modules: Module[]
  }
  meta: MetaData
}
